import React from 'react';

import type { Control } from 'react-hook-form';

import TextFieldComp from '@/components/TextFieldComp';
import TimeFieldComp from '@/components/TimeFieldComp';
import { Temperature } from '@/domain/temperature/service/entity/valueObjects/temperature';

/**
 * TemperatureInputType
 */
export type TemperatureInputType = {
  /** 体温 */
  temperature: string,
  /** 測定日時 */
  measureDateTime: string,
}

/**
 * TemperatureFormInputType
 */
export type TemperatureFormInputType = {
  /** コントロール */
  control: Control<TemperatureInputType, never>,
  /** エラー */
  errors: any,
}

const TemperatureFormInput: React.FC<TemperatureFormInputType> = ({
  control,
  errors,
}) => (
  <div>
    <TextFieldComp
      type={Temperature.type}
      control={control}
      rules={Temperature.validationRule}
      name={Temperature.key}
      label={Temperature.label}
      placeholder={Temperature.placeholder}
      errors={errors}
    />
    <TimeFieldComp
      control={control}
      name="measureDateTime"
      label="日時"
      rules={{
        required: '必須項目です',
      }}
      errors={errors}
    />
  </div>
);

export default TemperatureFormInput;
